import _ from 'lodash';
import api from '../../../services/CoreAPI';
import * as types from './action-types';

const fetchOffers = (queryParams = {}) => ({
    asyncAction: () => api.offers.get(queryParams)
        .then((response) => {
            // Used in Google Tag Manager dataLayer
            const loanId = _.get(response, 'data.loanId', '');
            const underwritingCard = _.get(response, 'data.cardId', '');
            console.info({ loanId, underwritingCard });
            loanId && window.dataLayer.push({
                event: 'LOAN_OFFER_PRESENTED',
                loanId,
                underwritingCard
            });
            return response;
        })
        .catch((error) => {
            throw error;
        }),
    type: types.OFFERS_GET,
});

const pendingOffers = () => ({
    type: types.OFFERS_GET_PENDING
});

const receivedOffers = (res) => ({
    type: types.OFFERS_GET_SUCCESS,
    res,
});

export default {
    fetchOffers,
    pendingOffers,
    receivedOffers
};
